import { useCallback, useRef } from "react";
import { GlobalStyles, useTheme } from "@mui/material";

export const SORTABLE_HELPER_CLASS = "app-sortable-helper";

export const SORTABLE_ROW_ATTR = "data-sortable-row";

export const SortableHelperStyles = () => {
    const theme = useTheme();
    return (
        <GlobalStyles
            styles={{
                [`.${SORTABLE_HELPER_CLASS}`]: {
                    zIndex: theme.zIndex.modal,
                    backgroundColor: theme.palette.background.default,
                    boxShadow: theme.shadows[8],
                    cursor: "grabbing",
                    listStyle: "none",
                },
            }}
        />
    );
};

export const useSortableHelperContainer = () => {
    const helperContainerRef = useRef<HTMLDivElement>(null);
    const getHelperContainer = useCallback(
        () => helperContainerRef.current || document.body,
        [],
    );

    const clearHelpers = useCallback(() => {
        const container = helperContainerRef.current;
        if (!container) return;
        while (container.firstChild)
            container.removeChild(container.firstChild);
    }, []);

    const clearStaleHelpers = useCallback(() => {
        const container = helperContainerRef.current;
        if (!container) return;
        while (container.children.length > 1)
            container.removeChild(container.firstChild);
    }, []);

    const resetSortableTransforms = useCallback((root: HTMLElement | null) => {
        if (!root) return;
        root.querySelectorAll<HTMLElement>(`[${SORTABLE_ROW_ATTR}]`).forEach(
            (el) => {
                el.style.transform = "";
                el.style.transition = "";
            },
        );
    }, []);

    return {
        helperContainerRef,
        getHelperContainer,
        clearHelpers,
        clearStaleHelpers,
        resetSortableTransforms,
    };
};
